import loadjs from "loadjs";
const KAMELEOON_LOAD_TIMEOUT = 1000;
let instance;
const asyncKameleoon = async ({ siteCode, host = "kameleoon.eu", logger, timeout = KAMELEOON_LOAD_TIMEOUT, consented, }) => {
    if (instance) {
        return instance;
    }
    const init = async () => {
        if (window.Kameleoon || consented === false) {
            return;
        }
        let timeoutId;
        try {
            await Promise.race([
                loadjs(`//${siteCode}.${host}/engine.js`, { returnPromise: true }),
                new Promise((resolve) => {
                    timeoutId = setTimeout(resolve, timeout);
                }),
            ]);
        }
        catch (error) {
            logger.captureException(error);
        }
        finally {
            clearTimeout(timeoutId);
        }
    };
    const assignedVariantByExperimentId = ({ experimentId }) => {
        let variation = undefined;
        if (window.Kameleoon && !navigator.webdriver && experimentId) {
            window.Kameleoon.API.Core.load();
            const experiment = window.Kameleoon.API.Experiments.getById(experimentId);
            if (experiment && experiment.associatedVariation) {
                variation = experiment.associatedVariation;
            }
        }
        return variation;
    };
    const trackConversion = ({ goalId }) => {
        if (window.Kameleoon) {
            window.Kameleoon.API.Core.load();
            window.Kameleoon.API.Goals.processConversion(goalId);
        }
    };
    instance = {
        assignedVariantByExperimentId,
        trackConversion,
    };
    await init();
    return instance;
};
export { asyncKameleoon };
